import {
  utils,
} from '@ama-sdk/core';
import {
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  CheckInFlightIdObjectRepository,
  combineCheckInFlightIdObjects,
  combineJourneys,
  createBoardingPassEligibility,
  createCheckInFlight,
  createEligibility,
  createJourney,
  createJourneyElement,
  createTraveler,
  JourneyElementCommonRepository,
  MockJourney,
} from '@dapi/sdk/spec';

const mockFlight1 = createCheckInFlight({
  template: {
    id: 'CHECK-IN-FLIGHT-0-MOCK',
    departure: {
      locationCode: 'NCE'
    },
    arrival: {
      locationCode: 'LHR'
    },
    acceptanceStatus: 'opened'
  }
});

const mockFlight2 = createCheckInFlight({
  template: {
    id: 'CHECK-IN-FLIGHT-1-MOCK',
    departure: {
      locationCode: 'LHR'
    },
    arrival: {
      locationCode: 'FRA'
    },
    acceptanceStatus: 'closed'
  }
});

const traveler = createTraveler({
  template: {
    passengerTypeCode: 'ADT',
    names: [{
      firstName: 'John',
      lastName: 'Doe',
      title: 'MR'
    }],
    id: 'JOURNEY-TRAVELER-0-MOCK'
  }
});

export const journeys: MockJourney[] = combineJourneys([
  {
    travelers: [traveler],
    flights: combineCheckInFlightIdObjects([
      createCheckInFlight({
        template:
        {
          ...CheckInFlightIdObjectRepository.NCE_LHR,
          acceptanceStatus: 'opened'
        }
      }),
      createCheckInFlight({
        template:
        {
          ...CheckInFlightIdObjectRepository.LHR_FRA,
          acceptanceStatus: 'closed'
        }
      })
    ]).items,
    acceptanceEligibility: createEligibility({
      template: {
        status: 'eligible',
        eligibilityWindow: {
          closingDateAndTime: new utils.DateTime(new utils.DateTime().getTime() + 24 * 3600 * 1000),
          openingDateAndTime: new utils.DateTime(new utils.DateTime().getTime() - 24 * 3600 * 1000)
        }
      }
    }),
    journeyElements: [
      {
        id: 'JOURNEY-ELEMENT-0-MOCK',
        journeyElement: createJourneyElement({
          template: {
            acceptanceEligibility: createEligibility({
              template: {
                status: 'eligible'
              }
            }),
            boardingPassEligibility: createBoardingPassEligibility({
              template: {
                status: 'eligible'
              }
            }),
            travelerId: 'JOURNEY-TRAVELER-0-MOCK',
            flightId: 'CHECK-IN-FLIGHT-0-MOCK',
            flight: mockFlight1
          }
        })
      },
      {
        id: 'JOURNEY-ELEMENT-1-MOCK',
        journeyElement: createJourneyElement({
          template: {
            acceptanceEligibility: createEligibility({
              template: {
                status: 'ineligible',
                reasons: ['flightAcceptanceStatus']
              }
            }),
            boardingPassEligibility: createBoardingPassEligibility({
              template: {
                status: 'eligible'
              }
            }),
            travelerId: 'JOURNEY-TRAVELER-0-MOCK',
            flightId: 'CHECK-IN-FLIGHT-1-MOCK',
            flight: mockFlight2
          }
        })
      }
    ]
  }
]).items;

export const chosenJourney: MockJourney = journeys[0];

export const partialAcceptedChosenJourney: MockJourney = createJourney({
  template: {
    ...chosenJourney,
    acceptance: {
      isAccepted: false,
      isPartial: true,
      checkedInJourneyElements: [{
        id: 'JOURNEY-ELEMENT-0-MOCK',
        journeyElement: createJourneyElement({
          template: {
            flight: mockFlight1,
            acceptanceEligibility: createEligibility({
              template: {
                status: 'eligible'
              }
            }),
            boardingPassEligibility: createBoardingPassEligibility({
              template: {
                status: 'eligible'
              }
            }),
            travelerId: 'JOURNEY-TRAVELER-0-MOCK',
            traveler: traveler,
            flightId: 'CHECK-IN-FLIGHT-0-MOCK',
            checkInStatus: 'accepted'
          }
        })
      }],
      notCheckedInJourneyElements: [{
        id: 'JOURNEY-ELEMENT-1-MOCK',
        journeyElement: createJourneyElement({
          template: {
            flight: mockFlight2,
            acceptanceEligibility: createEligibility({
              template: {
                status: 'ineligible',
                reasons: ['flightAcceptanceStatus']
              }
            }),
            boardingPassEligibility: createBoardingPassEligibility({
              template: {
                status: 'ineligible',
                reasons: ['passengerNotAccepted']
              }
            }),
            travelerId: 'JOURNEY-TRAVELER-0-MOCK',
            traveler: traveler,
            flightId: 'CHECK-IN-FLIGHT-1-MOCK',
            checkInStatus: 'notAccepted'
          }
        })
      }]
    },
    journeyElements: [
      {
        ...JourneyElementCommonRepository.DEFAULT,
        journeyElement: createJourneyElement({
          template: {
            flight: mockFlight1,
            acceptanceEligibility: createEligibility({
              template: {
                status: 'eligible'
              }
            }),
            boardingPassEligibility: createBoardingPassEligibility({
              template: {
                status: 'eligible'
              }
            }),
            travelerId: 'JOURNEY-TRAVELER-0-MOCK',
            flightId: 'CHECK-IN-FLIGHT-0-MOCK',
            checkInStatus: 'accepted'
          }
        })
      },
      {
        ...JourneyElementCommonRepository.DEFAULT,
        journeyElement: createJourneyElement({
          template: {
            flight: mockFlight2,
            acceptanceEligibility: createEligibility({
              template: {
                status: 'ineligible',
                reasons: ['flightAcceptanceStatus']
              }
            }),
            boardingPassEligibility: createBoardingPassEligibility({
              template: {
                status: 'ineligible',
                reasons: ['passengerNotAccepted']
              }
            }),
            travelerId: 'JOURNEY-TRAVELER-0-MOCK',
            flightId: 'CHECK-IN-FLIGHT-1-MOCK',
            checkInStatus: 'notAccepted'
          }
        })
      }
    ]
  }
});

export const journeyElementIds: string[] = chosenJourney.journeyElements.map((je: JourneyElementCommon) => je.id);
